export default { 
    // 获取浏览器名称
    getBrowserName() {
        const userAgent = navigator.userAgent; 
        if (userAgent.indexOf("Firefox") != -1) {
            return "Mozilla Firefox";
        } else if (userAgent.indexOf("OPR") != -1) {
            return "Opera";
        } else if (userAgent.indexOf("Trident") != -1) {
            return "Microsoft Internet Explorer";
        } else if (userAgent.indexOf("Safari") != -1) {
            return "Apple Safari";
        } else if (userAgent.indexOf("Edge") != -1) {
            return "Microsoft Edge";
        } else if (userAgent.indexOf("Chrome") != -1) {
            if (userAgent.indexOf("Edg") != -1) {
                return "Microsoft Edge";
            } else {
                return "Google Chrome";
            }
        } else if (userAgent.indexOf("Safari") != -1) {
            return "Apple Safari";
        } else {
            return "Unknown";
        }
    }
}